
ACC.product = {

	bindAll : function() {
		ACC.product.bindToAddToCartForm();
		ACC.product.bindToAddToCartStorePickUpForm();
		ACC.product.bindToAddToCartButton();
		ACC.product.bindBuyOnline();
		ACC.product.isMobile();
	},

	bindToAddToCartButton : function() {
		$('#addToCartButton').attr("disabled", null);
	},

	isMobile : function(){

        var isTablet, isMobile900, isMobile;

        	if ($(document).width() < 768) {
            	isMobile = true;
            } else {
                isMobile = false;
            }
    },

	countrySelector : function() {
		$('#CountrySeletorBC').click(function() {
			  $('#country-selector-bc').toggle();
			});

			$('#country-selector-bc').mouseleave(function() {
			    $('#country-selector-bc').hide();
			});
	},


	bindToAddToCartForm : function() {
        $(document).on('submit','.add_to_cart_form', function (event) {
            event.preventDefault();
            $('.add-panier').attr('disabled', true);
            $.ajax({
                url: ACC.config.contextPath + $(this).prop('action'),
                data: $(this).serialize(),
                method: $(this).prop('method'),
                beforeSend: function (arr, $form, options) {
                    $('.add-panier').attr('disabled', true);
                },
            }).done(function (data) {
                ACC.product.displayAddToCartPopup(data)
            }).fail(function () {
                $('.add-panier').attr('disabled',true);
            });
        });

        $("button.add-to-cart").attr("type", "submit");

		$('.add-to-cart-upgrade-companion').click(function(event)
		{
			//  arr�ter l'effet du click
			event.preventDefault();

			// r�cuperer le code produit depuit la form ( closest est utilis� parce que la str�cture n'est pas unique il r�cupere celui l'input 'productCodePost' le plus proche a "form"
			codeProduit = $(this).closest('form').find("[name='productCodePost']").val();
			if(codeProduit != null && codeProduit !="")
			{
				$.ajax({
					url : ACC.config.contextPath+"/cart/add/companion/ajax",async : false
				}).done(function(data) {

					selectModal="#ModalMessage";
					$(selectModal).html(data);
					$(selectModal).show();
					$(selectModal).modal();
					$(".companion-product-code").val(codeProduit);
				});

			}
			else
			{
						selectModal="#ModalMessage";
						$(selectModal).html("technical problem");
						$(selectModal).show();
						$(selectModal).modal();
			}
		});
	},

	bindToAddToCartStorePickUpForm : function() {
        $('.add_to_cart_storepickup_form').on('submit',
            function (event) {
                event.preventDefault();
                $.ajax({
                    url: ACC.config.contextPath + $(this).prop('action'),
                    data: $(this).serialize(),
                    method: $(this).prop('method')
                }).done(function (data) {
                    ACC.product.displayAddToCartPopup(data)
                });
            }
        );
    },

	displayAddToCartPopup : function(cartResult, statusText, xhr, formElement) {
        $('.add-panier').attr('disabled', null);
		// update mini cart
		if (typeof ACC.cartpopup.refreshMiniCart == 'function') {
			ACC.cartpopup.refreshMiniCart();
		}

		// display add to cart confirmation
		var modalId = "ModalProductBuy";
		if (!cartResult.cartError.msg.length == 0) {
			modalId = "ModalCartError";
			$('body')
					.append(
							$('<div />')
									.html(cartResult.cartError.msgModalHtml)
									.text());
		} else {
			$('body')
					.append($('<div />').html(cartResult.cartModalHtml).text());
		}
		// Add modal
		var selectModal = '#' + modalId;
		$(selectModal).show();
		$(selectModal).modal();

		// Ajout fonction sur l'event hide pour supprimer la modal
		$(selectModal).on('hidden.bs.modal', function() {
			$(selectModal).remove();
		});

		// send analytics event
		var productCode = $('[name=productCodePost]', formElement).val();
		var quantityField = $('[name=qty]', formElement).val();

		var quantity = 1;
		if (quantityField != undefined) {
			quantity = quantityField;
		}
		ACC.product.trackAddToCart(productCode, quantity, cartResult);
	},

	trackAddToCart : function(productCode, quantity, cartData) {
		window.mediator.publish('trackAddToCart', {
			productCode : productCode,
			quantity : quantity,
			cartData : cartData
		});
	},

	//BRA-1232
	showCCnotFoundMessages : function()
	{
		//afficher les messages d'erreur qu'aucun distributeur n'est trouv�
		$('.distributor-not-found-msg').show();

		//bind le click sur le message : buyonline.cc.nofound.find.store pour rediriger vers la popin buy in store
		$(document).on('click','.return-buy-in-store',function(e){
			e.preventDefault();
			$('.product-detail .buyinstore').trigger('click');
			});

		// cacher la zone des distributeurs
		$('#myCarouselBC').hide();
	},

	bindBuyOnline : function() {
        $(".return-buyonline").on("click", function (e) {
            e.preventDefault();
            $('.product-detail .buyonline').trigger('click');
        });
        $(".buyonline").on("click", function (e) {
            ACC.product.checkBuyOnline(this);
            e.preventDefault();
        });
        $(document).on('click', '.return-buy-in-store', function (e) {
            e.preventDefault();
            $('.product-detail .buyinstore').trigger('click');
        });
	},

	bindBuyOnlineChangeCountry : function() {
		$(document).on('click', '.buyonlineChangeCountry', function(e) {
		//$(".buyonlineChangeCountry").on("click", function(e) {
			e.preventDefault();
			ACC.product.checkBuyOnline(this);
		});
	},

	checkBuyOnline : function(element) {
		var seoUrl=null;
    	if($(element).parent().find('.buyonline[seo-data-url]').length != 0)
    	{
    		seoUrl=$(element).attr('seo-data-url');
    	}
    	else
    	{
    		seoUrl=$(element).attr('href');
    	}
		$.ajax({
			url : seoUrl  + "/ajax",async : false
		}).done(function(data) {
			console.log(data.message);
			// redirect dans le cas d'une erreur ou specific link
			if (data.reponseCode == 'redirect') {
				ACC.product.buyonlineRedirect(data.redirectUrl);
			} else if (data.reponseCode == 'open-popin' || data.reponseCode == 'open-ccs-not-found-popin') { // afficher popin (mm si aucun distributeur n'est trouv�) si aucun prb n'est servenu au WS et si le spesefic link n'est pas activ�
				ACC.product.displayBuyOnline(element,data.reponseCode);
			}
			;
		});
	},

	displayBuyOnline : function(element,redirectType) {
		$.ajax({
			url : $(element).attr('seo-data-url') + "/popin/ajax"
		}).done(function(html) {
			$("#ModalCommerce").addClass("modal-business");
			$("#ModalCommerce .modal-header").html(buyonlinePopinHeader);
			$("#ModalCommerce .modal-body").html(html);
			$("#ModalCommerce").show();
			$("#ModalCommerce").modal();

			ACC.product.countrySelector();
			ACC.product.bindBuyOnlineChangeCountry();

			// Ajout fonction sur l'event hide pour supprimer le contenu de la
			// modal
			$("#ModalCommerce").on('hidden.bs.modal', function() {
				$("#ModalCommerce .modal-body").html("");
				$("#ModalCommerce").removeClass("modal-business");
			});

			//#BRA-1232
			if (redirectType == 'open-ccs-not-found-popin')
			{
				ACC.product.showCCnotFoundMessages();
			}

            if ($(window).width() > 768) {
               if ($('.commerce-connector .item').length > 1) {
                   commerceConnectorSlider = $('.commerce-connector').bxSlider({
                       pager: true,
                       infiniteLoop: false,
                       auto: false,
                       hideControlOnEnd: true,
                       onSliderLoad: function () {
                           $('.commerce-connector').parents('.bx-wrapper').addClass('commerce-connector-wrapper')
                       }
                   });
               }
            } else {
               $('.commerce-connector .seller').each(function() {
                   $('.commerce-connector').append($(this));
               });
               $('.commerce-connector .item').remove();

               commerceConnectorSlider = $('.commerce-connector').bxSlider({
                   pager: false,
                   infiniteLoop: false,
                   auto: false,
                   hideControlOnEnd: true,
                   slideWidth: 240,
                   onSliderLoad: function () {
                       $('.commerce-connector').parents('.bx-wrapper').addClass('commerce-connector-wrapper')
                   }
               });
            }

            $('#ModalCommerce').find('.modal-body').css({
                'max-height': '100%'
            });

			// bind function for product range on select change
			$('#SelectbusinessRange').change(function(event) {
				if ($('#SelectbusinessRange').val() != '') {
					$.ajax({
						type : "GET",
						url : $('#SelectbusinessRange').val()
					}).done(function(data) {
						var IS_JSON = true;
						try {
							console.log(data);
							var json = $.parseJSON(data);
							console.log(json.message);

							// il faut rediriger vers where to buy seulement si on a un spesific link = ( cad : redirect avec aucun message d'erreur )
							if (json.reponseCode == 'redirect' && json.errorMessage=='' )
							{
								ACC.product.buyonlineRedirect(json.redirectUrl);
							} else {
								ACC.product.showCCnotFoundMessages();
							}

						} catch (err) {
							IS_JSON = false;
						}

						if (!IS_JSON) {

							//BRA-1232
							// supprimer les message d'erreurs distributeur Not found, qui peuvent etre affich� pr un autre produit qui n'a aucun distributeur
							$('.distributor-not-found-msg').hide();

							// data is ur summary
							$('#StoreConnectorAjax').html(data);
							//Analytic.bindAllEvents($("#StoreConnectorAjax"));
							// activate carrousel
							$('#myCarouselBC').carousel({
								interval : 10000
							});
							$('#myCarouselBC').carousel('cycle');

						}
					}).fail(function(data) {
						$('#StoreConnectorAjax').html("Error");
					});

				}
			});




		}).fail(function(html) {
			$("#ModalCommerce .modal-body").html(html.responseText);
			$("#ModalCommerce").show();
			$("#ModalCommerce").modal();

			// Ajout fonction sur l'event hide pour supprimer le contenu de la
			// modal
			$("#ModalCommerce").on('hidden.bs.modal', function() {
				$("#ModalCommerce .modal-body").html("");
			});




		});
	},
	buyonlineRedirect : function(url) {
		var a =  $("#buyonline-redirect-link");
		a.attr("href", url);

		// check external url
		var hostRegEx = new RegExp(location.host);
		var absoluteUrlRegEx = new RegExp('^(?:[a-z]+:)?//', 'i');
		if (! absoluteUrlRegEx.test(url)  ) {
			// a link that contains the current host
			// so open the link into the same window
			 a[0].click();
		} else {
			// a link that does not contain the current host
			// //so open the link in another window
//			 window.open(url, '_blank').focus();
//			window.location.href = url;
			a.attr("target", "_blank");

			 a[0].click();
			// create a temporary form with the href of the link as action and method as get.
//			$('<form/>')
//			  .attr('id', 'dummyForm')
//			  .attr('action', url)
//			  .attr('target', "_blank")
//			  .attr('method', 'get')
//			  .appendTo('body')
//			  .submit(); // submit it
//
// setTimeout(function() {
// $('#dummyForm').remove(); // remove the temp form
// }, 100);
		}
	},

	positionSuccessStoresNearMeGglApi: function (position)
	{

	  var lat= position.coords.latitude;
   	  var lng=position.coords.longitude;
   	  if(lat!=null && lat !=undefined && lng!=null && lng!=undefined  ){
   			var url = $("#buyInStoreForm").attr('action');
   	        if($("#SelectbusinessRange").val()!=null){
   	        	url=$("#SelectbusinessRange").val();
   	        }
   			jQuery.ajax({
   		     type: "GET",
   		     url: url,
   		     data: "&lng="+lng+"&lat="+lat+"&"+$("#buyInStoreForm").serialize()
            }).done(function(data) {
   		    	  initScrollingStoreList();
   		          $('#MapStoreStok').html(data);
   		          ACC.product.bindBuyOnline();
   		   	});

   		}
	},

	bindAutoLocationDirectionButtonClick: function ()
	{
  		$(document).on("click", ".btn-direction", function (e)

				{


					//e.preventDefault();
//					var repairlongitude=$(this).attr("long");
//					var repairlatitude=	$(this).attr("lat");

					var repairlongitude=$(this).data("repairlongitude");
					var repairlatitude=	$(this).data("repairlatitude");

			    	jQuery.post( "https://www.googleapis.com/geolocation/v1/geolocate?key="+getGglAPIKey(),function(position){
						ACC.userlocation.directionToRepairCenterGglApi(position,repairlongitude,repairlatitude);
					})
			    	  .fail(function(err) {
			    		  console.log("API Geolocation error! \n\n"+err);
			    	});


				});
	}


};

$(document).ready(function() {
	ACC.product.bindAll();

});

function getGglAPIKey(){
	var key = null;
    jQuery.ajax({
        type: "GET",
        url:"/buyonline/gglApiKey/ajax",
        async:false
    }).done(function (data) {

        	key=data;

    }).fail(function(xhr, status, error) {
        	console.log("Cannot get key api !");
    });
    return key;
}
